module.exports = __webpack_public_path__ + "media/images/ohap_Folder_Open-57fd6be8ab521d5b30e63a3d2f1e16b0.png";